import { useCallback } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "./api";
import { syncUserTimezone } from "./timeFmt";

// Shared, deduped fetches (W7): one cache entry + at most one in-flight GET per
// endpoint app-wide, regardless of how many components subscribe. Interval =
// smallest refetchInterval among mounted subscribers (react-query semantics).
function useShared(key, path, intervalMs) {
  const qc = useQueryClient();
  const q = useQuery({
    queryKey: key,
    queryFn: () => api.get(path).then((r) => r.data),
    refetchInterval: intervalMs || false,
    retry: 1,
  });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const reload = useCallback(() => qc.invalidateQueries({ queryKey: key }), [qc]);
  return [q.data ?? null, reload, q.isError];
}

export const useTypes = (intervalMs = 60000) => useShared(["types"], "/types", intervalMs);
export const useMe = (intervalMs = 4000) => {
  const r = useShared(["auth-me"], "/auth/me", intervalMs);
  if (r[0]) syncUserTimezone(r[0].timezone || "");
  return r;
};
